import { createSlice } from "@reduxjs/toolkit";
import {
  AddReportReasonAction,
  DeleteReportReasonAction,
  GetAllReportReasonAction,
  UpdateReportReasonAction,
} from "store/middlewares/dataManagement/reportReason";

// isDeleteMeFulFilled
export const reportReasonSlice = createSlice({
  name: "reportReasons",
  initialState: {
    reportReasonsLoading: true,
    reportReasons: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllReportReasonAction.pending, (state) => {
        // state.reportReasonsLoading = true;
        // state.reportReasons = null;
        state.reportReasons =
          state.reportReasons?.data?.length > 0 ? state.reportReasons : null;
      })
      .addCase(GetAllReportReasonAction.fulfilled, (state, action) => {
        state.reportReasonsLoading = false;
        state.reportReasons = action.payload.response;
      })
      .addCase(GetAllReportReasonAction.rejected, (state) => {
        state.reportReasonsLoading = false;
        state.reportReasons = null;
      })

      // Delete
      .addCase(DeleteReportReasonAction.fulfilled, (state, action) => {
        // state.reportReasonsLoading = false;
        // state.reportReasons = {
        //   ...state.reportReasons,
        //   total: Number(state.reportReasons.total) - 1,
        //   data: state.reportReasons?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.reportReasonsLoading = false;
        state.reportReasons = action.payload.response;
      })

      //Update
      .addCase(UpdateReportReasonAction.fulfilled, (state, action) => {
        state.reportReasonsLoading = false;
        state.reportReasons = {
          ...state.reportReasons,
          data: state.reportReasons.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddReportReasonAction.fulfilled, (state, action) => {
        // state.reportReasonsLoading = false;
        // state.reportReasons = {
        //   ...state.reportReasons,
        //   total: Number(state.reportReasons.total) + 1,
        //   data: [action.payload.response, ...state.reportReasons.data],
        // };
        state.reportReasonsLoading = false;
        state.reportReasons = action.payload.response;
      });
  },
});

export default reportReasonSlice.reducer;
